import { ISendingMessage } from "src/app/chat/~store/models/MessageInfo";
import { IButton, IMessage } from "src/app/chat/~store/models/messages/Message";

export interface IMessageProps {
    message: IMessage,
    isButtonsDisabled: boolean,
    setForceButtonDisabled(disabled: boolean): void;
    onMenuButtonClick(button: IButton): void,
    customerId: string,
    sendingMessage?: ISendingMessage,
    mapProvider?: MapProvider,
}

export enum MapProvider
{
    Google = 1,
    Yandex = 2
}